<template>

	<div class="game-info">
		<div class="" :class="gridClass">
			<div v-if="showAboutSection" class="game-info__section" :class="gridItemClass">

				<h3 class="h5 game-info__title">About this game</h3>
				<div class="game-info__description fc-pal--grey">{{game.gameDescription}}</div>
				<a class="link--action link--arrow link--colored game-info__download" v-if="$root.userHasPermission({
					'igt': ['AM', 'CM', 'SA'],
					'operator': ['customer', 'performance'],
				}) && game.assets.downloadableGameinformation && game.assets.downloadableGameinformation.length > 0" :href="game.assets.downloadableGameinformation[0].link" target="_blank">Download Game Info</a>

			</div>
			<div class="game-info__section" :class="gridItemClass">

				<h3 class="h5 game-info__title">Information</h3>
				<div class="game-info__table fc-pal--grey">
					<div class="game-info__table-key">3rd Party Licensed</div>
					<div class="game-info__table-spacer"></div>
					<div class="game-info__table-value">
						<template v-if="game.thirdPartyLicenced">Yes</template>
						<template v-else>No</template>
					</div>
				</div>
				<div v-if="game.mechanic !== 'mechanic-none'" class="game-info__table fc-pal--grey">
					<div class="game-info__table-key">Game Mechanic</div>
					<div class="game-info__table-spacer"></div>
					<div class="game-info__table-value">{{mechanicLabels([game.mechanic]).join(', ')}}</div>
				</div>
				<div v-if="game.theme !== 'theme-none'" class="game-info__table fc-pal--grey">
					<div class="game-info__table-key">Theme</div>
					<div class="game-info__table-spacer"></div>
					<div class="game-info__table-value">{{themeLabels([game.theme]).join(', ')}}</div>
				</div>
				<!--<div v-if="game.features !== 'feature-none'" class="game-info__table fc-pal--grey">
					<div class="game-info__table-key">Special Feature</div>
					<div class="game-info__table-spacer"></div>
					<div class="game-info__table-value">{{featureLabels([game.features]).join(', ')}}</div>
				</div>-->

			</div>
			<div class="game-info__section" :class="gridItemClass">

				<h3 class="h5 game-info__title">Supported Languages</h3>
				<div class="game-info__languages fc-pal--grey">English - Additional languages can be supported upon request.  Contact your Account Manager.</div>

			</div>
			<div class="game-info__section" :class="gridItemClass">

				<h3 class="h5 game-info__title">RTP</h3>
				<div class="game-info__rtp fc-pal--grey">Customers define their own RTP via approved prize structure.</div>

			</div>
		</div>
	</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'GameDetail',
	components: {
	},
	data () {
		return {
		}
	},
	props: {
		game: Object,
		gridClass: {
			type: String,
			default: 'grid grid--g40 grid--s64'
			// <attr class="grid grid--g40 grid--s64" />
		},
		gridItemClass: {
			type: String,
			default: 'grid__item one-half--not-phab'
			// <attr class="grid__item one-half--not-phab" />
		},
		showAboutSection: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		...mapGetters({
  		'featureLabels': 'app/featureLabels',
  		'themeLabels': 'app/themeLabels',
  		'mechanicLabels': 'app/mechanicLabels',
		}),
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">

	@import "src/scss/vars/attract";
	@import "src/scss/toolkit";

	$c: ".game-info";
	#{$c}
	{
		font-size: 14px;

		&__section
		{
			&:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5)
			{
				&:before
				{
					content: "";
					display: block;
					position: relative;
					top: -32px;
					border-bottom: 1px solid palette(lightest-grey);

					@include media(phab)
					{
						border-bottom-color: palette('divider');
						top: -24px;
					}
				}
			}

			&:nth-child(2)
			{
				&:before
				{
					@include media(not-phab)
					{
						display: none;
					}
				}
			}
		}

		&__title
		{
			margin-bottom: rem(24);
			@include extend(heading--bold);
		}

		&__download
		{
			display: inline-block;
			margin-top: rem(32);
		}

		&__table
		{
			@include extend(grid);
			@include extend(grid--b0);
			@include extend(grid--bottom);
			@include extend(grid--auto);
			@include extend(grid--no-wrap);
			margin-bottom: 1em;

			&-key,
			&-spacer,
			&-value
			{
				@include extend(grid__item);
			}

			&-key
			{
				padding-right: 5px;
			}

			&-spacer
			{
				flex-grow: 1;

				@include media(not-phab)
				{
					border-bottom: 1px dotted;
				}
			}

			&-value
			{
				@include extend(font--bold);
				padding-left: 5px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameInfo.vue